import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  direction: 'rtl',
  palette: {
    mode: 'dark',
    primary: {
      main: '#2196F3', // Bright Blue
      light: '#64B5F6',
      dark: '#1976D2',
    },
    secondary: {
      main: '#1565C0', // Deep Blue
      light: '#42A5F5',
      dark: '#0D47A1',
    },
    background: {
      default: '#000000', // Pure Black
      paper: '#0A0A0A', // Near Black
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B0BEC5',
    },
    success: {
      main: '#00E676',
    },
    error: {
      main: '#FF1744',
    },
  },
  typography: {
    fontFamily: '"Cairo", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 700,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(145deg, #0A0A0A 0%, #1A1A2E 100%)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(33, 150, 243, 0.2)',
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;